import { Attribute, Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[app-filter]'
})
export class InputFilterDirective {
    regExpattern: RegExp;

    constructor(@Attribute('pattern') pattern: string, private control: NgControl) {
        this.regExpattern = new RegExp(pattern);
    }

    @HostListener('input', ['$event'])
    onInputChange(event: Event) {
        const test = this.regExpattern.test((event.target as HTMLInputElement).value);
        if (test) {
            (event.target as HTMLInputElement).defaultValue = (event.target as HTMLInputElement).value;
        } else {
            this.control?.control?.setValue((event.target as HTMLInputElement).defaultValue);
        }
    }
}
